import { useNextSanityImage } from 'next-sanity-image'
import type { SanityImageSource } from '@sanity/image-url/lib/types/types'
import { getClient } from 'clients/sanity'

export const useSanityImage = (asset: SanityImageSource) => {
  return useNextSanityImage(getClient(false), asset)
}
